module.exports = __webpack_public_path__ + "static/media/folder1.29239de4.png";